"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UILanguage_1 = require("../UILanguage");
var UIUtils_1 = require("../../shared/modules/UIUtils");
var VersionInfo = /** @class */ (function (_super) {
    __extends(VersionInfo, _super);
    function VersionInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VersionInfo.prototype.componentWillMount = function () {
        this.setState({
            lang: UILanguage_1.IUILanguageFactory.getLangInstance(this.props.state.getLang())
        });
    };
    VersionInfo.prototype.getText = function () {
        return UIUtils_1.UIUtils.FormatStr(this.state.lang.version.text_fmt, ["1.7.242", "19.03.2025"]);
    };
    VersionInfo.prototype.render = function () {
        var _css = {
            height: "64px",
            maxHeight: "64px",
            minWidth: "150px",
            color: "#D3D3D3",
            fontSize: "16px",
            overflow: "hidden"
        };
        return (React.createElement("div", { style: _css },
            this.getText(),
            " - [ORG_ID: ",
            this.props.orgId,
            "]"));
    };
    return VersionInfo;
}(React.Component));
exports.default = VersionInfo;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/VersionInfo.tsx
// module id = 1744
// module chunks = 0